import { LocationContact } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useLocationContacts(locationId: number, enabled = true) {
  const url = `/v2/orm/locations/${locationId}/contacts`;
  const request = new Request(url);

  return useAuthenticatedRequest<LocationContact[]>(request, {
    queryKey: ['location-contacts', { locationId }],
    enabled: enabled && !!locationId,
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useLocationContacts;
